import { type ObjectValuesUnionType } from '../utils/typing';

export const SeparatorTypes = Object.freeze({
  FAVORITES: 'favorites',
  LIVE: 'live',
  STANDARD: 'standard',
});

export type SeparatorType = ObjectValuesUnionType<typeof SeparatorTypes>;
